// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "5d79fc60-dirty",
    "hash": "5d79fc60",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "5d79fc60-dirty",
    "semverString": null,
    "devVersion": "0.81.0",
    "branch": null
};
/* tslint:enable */
